// extracted by mini-css-extract-plugin
module.exports = {"spin":"_08127b8","ldsDualRing":"_c2cd053"};